import React from 'react'
import { Typography, Container, Divider, SwitchButton, ButtonSize } from '@cleartrip/ct-design-components'
import { PossibleFilterTypes } from '@/types/srp'
import { filterTypes } from '@/constants/Srp'
import Image from 'next/image'

// Props type for CtUpgradeFilter component
type CtUpgradeFilterProps = {
  onFilterChange: (type: PossibleFilterTypes, filtersData: { enabled: boolean; checked: boolean }) => void
  selectedFilters: any
  isRevamp?: boolean
}

const CtUpgradeFilter = ({ onFilterChange, selectedFilters, isRevamp = false }: CtUpgradeFilterProps) => {
  const { ctUpgrade: onwardCtUpgrade } = selectedFilters?.onwardLeg || {}
  const { ctUpgrade: returnCtUpgrade } = selectedFilters?.returnLeg || {}
  const ctUpgradeEnabled = onwardCtUpgrade || returnCtUpgrade
  const currentCtUpgrade = selectedFilters?.ctUpgrade || { enabled: ctUpgradeEnabled || false, checked: false }

  const handleToggle = () => {
    const newState = {
      ...currentCtUpgrade,
      checked: !currentCtUpgrade.checked,
    }
    onFilterChange(filterTypes.CT_UPGRADE, newState)
  }

  return (
    <Container className={isRevamp ? 'flex flex-column flex-rg-3' : 'br-8 ba mt-3 mb-4'}>
      <Container className={isRevamp ? undefined : 'p-3'}>
        <Image
          src='https://static-assets-ct.flixcart.com/ct/assets/resources/images/Frame%20321.png'
          alt='CtUpgrade'
          height={19}
          width={103}
        />
        <Typography variant='P2' color='subheading' className='pt-1'>
          Get free/discounted seat & meal with Cleartrip upgrade
        </Typography>
      </Container>
      <Divider borderStyle='dashed' />
      <Container className={isRevamp ? 'flex' : 'flex p-3'}>
        <Typography variant={isRevamp ? 'P2' : 'B2'}>Show CT upgrade flights</Typography>
        <Container className='pl-4'>
          <SwitchButton checked={currentCtUpgrade.checked} onChange={handleToggle} size={ButtonSize.SMALL} />
        </Container>
      </Container>
    </Container>
  )
}

export default CtUpgradeFilter
